
import Vue from "vue";
export default Vue.extend({
	props: {
		label: {
			type: [Object, String]
		},
		// eslint-disable-next-line vue/require-prop-types
		value: {
		},
		decimals: {
			type: Number,
			default: 2
		},
		textarea: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		hasValue():boolean{
			return this.value != null && this.value !== "";
		},
		computedValue():any{
			if (typeof(this.value) == "boolean"){
				if (this.value){
					return this.$t("common.yes");
				}
				return this.$ct("common.no");
			}
			if (typeof(this.value) == "number"){
				return this.value.toFixed(this.decimals);
			}

			let lines = ((this.value || "") + "").split("{__NEW_LINE__}");
			if (lines.length > 1) {
				return `${lines[0]}...`;
			}
			return lines[0] || "";
		}
	}
});
